// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3khqj","requiredAsterisk":"Info_requiredAsterisk__2fKC9"};